// 1. Alterado de require para import

import { enviarMensagemWhatsApp } from '../services/whatsappService.js';

function gerarMensagem(clienteNome, textoVencimento, valor) {
  return `Olá, ${clienteNome}.

Maxtra Mídia informa: sua fatura referente a exibição de publicidade no outdoor ${textoVencimento}.

Valor: R$ ${valor}

Pix CNPJ: 53831227000145
Gr Serviços empresariais e tecnologia

_Desconsidere esta mensagem caso já tenha efetuado o pagamento._

_Mensagem automática, favor não responder._`;
}

export async function sendMessage(clienteNome, telefone, vencimento, bearer, baseurl, valor) {
  const hoje = new Date();
  const partes = vencimento.split('-');
  const dataVencimento = new Date(
    parseInt(partes[0]),
    parseInt(partes[1]) - 1,
    parseInt(partes[2])
  );

  hoje.setHours(0, 0, 0, 0);
  dataVencimento.setHours(0, 0, 0, 0);

  const diffTime = dataVencimento - hoje;
  const diffDias = Math.round(diffTime / (1000 * 60 * 60 * 24));

  let textoVencimento = "";

  if (diffDias === 0) {
    textoVencimento = "vence hoje";
  } else if (diffDias === 1) {
    textoVencimento = "vence amanhã";
  } else if (diffDias > 1 && diffDias <= 2) {
    textoVencimento = `vence em ${diffDias} dias`;
  } else if (diffDias < 0) {
    textoVencimento = `venceu há ${Math.abs(diffDias)} dias`;
  } else {
    return; // Fora do intervalo de interesse, não envia mensagem
  }

  if (!telefone.startsWith('55')) {
    telefone = '55' + telefone;
  }

  const mensagem = gerarMensagem(clienteNome, textoVencimento, valor);

  // 2. Corrigido de "telefone" para "numero"
  const resultado = await enviarMensagemWhatsApp(telefone, mensagem, bearer, baseurl);
  // console.log(mensagem);

  
}


// TeamZapActived
// true
// (boolean)


// TeamZapBearer
// eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6MiwicHJvZmlsZSI6ImFkbWluIiwic2Vzc2lvbklkIjo0LCJpYXQiOjE3NTI1OTg2MDUsImV4cCI6MTgxNTY3MDYwNX0.tsPpzj8v6Ax7UGhf1sZP_am_z9ffrPOInK_iy6adYCE
// (string)


// TeamZapUrl
// https://teamzapapi.grempresas.com.br/v2/api/external/30b85077-afc6-4736-b2bc-4ef16aa08742